var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNav03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327",
    transform: "translate(1739.5 -22856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vectornav-1",
    d: "M2,.25H7A1.752,1.752,0,0,1,8.75,2V14A1.752,1.752,0,0,1,7,15.75H2A1.752,1.752,0,0,1,.25,14V2A1.752,1.752,0,0,1,2,.25Zm5,14A.25.25,0,0,0,7.25,14V2A.25.25,0,0,0,7,1.75H2A.25.25,0,0,0,1.75,2V14a.25.25,0,0,0,.25.25Z",
    transform: "translate(-1726.75 22860)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vectornav-2",
    d: "M2,.25H7A1.692,1.692,0,0,1,8.75,1.872V17.628A1.692,1.692,0,0,1,7,19.25H2A1.692,1.692,0,0,1,.25,17.628V1.872A1.692,1.692,0,0,1,2,.25ZM7,17.86a.242.242,0,0,0,.25-.232V1.872A.242.242,0,0,0,7,1.64H2a.242.242,0,0,0-.25.232V17.628A.242.242,0,0,0,2,17.86Z",
    transform: "translate(-1737 22856.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vectornav",
    d: "M21.548,1.75H.952A.727.727,0,0,1,.25,1a.727.727,0,0,1,.7-.75h20.6a.727.727,0,0,1,.7.75A.727.727,0,0,1,21.548,1.75Z",
    transform: "translate(-1738.5 22877)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNav03);
export default __webpack_public_path__ + "static/media/icon-nav-03.c11fe535ae3542d5d599b80c2a1da580.svg";
export { ForwardRef as ReactComponent };